/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { Instance } from "mobx-state-tree"
import { SubscribeSmsAddonResultDtoModelBase } from "./SubscribeSmsAddonResultDtoModel.base"

/* The TypeScript type of an instance of SubscribeSmsAddonResultDtoModel */
export interface SubscribeSmsAddonResultDtoModelType extends Instance<typeof SubscribeSmsAddonResultDtoModel.Type> {}

/* A graphql query fragment builders for SubscribeSmsAddonResultDtoModel */
export { selectFromSubscribeSmsAddonResultDto, subscribeSmsAddonResultDtoModelPrimitives, SubscribeSmsAddonResultDtoModelSelector } from "./SubscribeSmsAddonResultDtoModel.base"

/**
 * SubscribeSmsAddonResultDtoModel
 */
export const SubscribeSmsAddonResultDtoModel = SubscribeSmsAddonResultDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self))
    }
  }))
